import { Component, Input, OnInit } from '@angular/core';

import { OrderDetails } from 'src/app/models/order/order-details.model';

@Component({
    selector: 'order-details-banner-scheduled',
    templateUrl: './scheduled.component.html',
    styleUrls: ['./../banner-wrapper.component.scss', './scheduled.component.scss'],
    standalone: false
})
export class ScheduledComponent implements OnInit {

  @Input() order: any;

  constructor() { }

  ngOnInit(): void {
  }

}
